import {StyledProps, React, withStyles, _, classNames, computed, Fragment} from '@api'
import {listFilters} from '@api/graphql'
import {Button} from '@blueprintjs/core'
import {
  Card,
  CardMedia,
  Typography,
  Chip
} from '@material-ui/core'
import {nav, DragDropEventHandlers, CatalogStore, site} from '@stores'
import {FlatButton} from 'centric-ui-components'
import {Clear as ClearIcon, Add} from '@material-ui/icons'
import {landingScreen, LoadingIndicator} from '@design-board'
import {ProductCountPopOver} from '@modules/catalog/internal/gridList/components/ProductCountPopOver'
import {action, observable} from 'mobx'
import * as css from './ProductLanding.css'
import {observer} from 'mobx-react'
import {AddIcon, AddManyIcon } from '@stores/ui'

const styles = theme => ({
  landingContainer: {
    height: '100%'
  },
  landing: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: "center",
    alignItems: 'center',
    height: '100%',
    width: '100%'
  },
  alignment: {
    justifyContent: 'center'
  },
  emptyLibrary: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },

  progressIcon: {
    color: '#4184f3',
    position: 'fixed',
    top: '50%'
  },
  imageCard: {
    height: 177,
    width: 281,
    boxShadow: 'none'
  },
  imageCardMedia: {
    width: '100%',
    height: '100%'
  },
  helperText: {
    height: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    color: 'rgba(27, 27, 27, 0.54)'
  },
  emptyContainer: {
    height: '100%',
    flexGrow: 1,
    display: 'flex',
    alignContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'all 0.3s ease'
  },
  emptyWithSidebar: {
    height: '100%',
    width: 'calc(100vw - 272px)',
    marginLeft: 264,
    display: 'flex',
    alignContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'all 0.3s ease'
  },
  filterChips: {
    marginTop: 0,
    position: 'sticky',
    padding: '16px 20px 16px 0px',
    top: 0,
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    overflowX: 'auto',
    zIndex: 0,
    background: '#FFF',
    width: 'calc(100% - 30px)',
    height: 45,
    marginBottom: 50
  },
  chip: {
    margin: theme.spacing() / 2,
    borderRadius: 2,
    marginTop: 0,
    marginBottom: 0
  },
  noFilterChips: {
    display: 'none'
  },
  deleteIconStyle: {
    fontSize: 20
  },
  clearFilter: {
    position: 'sticky',
    left: 0,
    borderWidth: '4px 0px',
    borderStyle: 'solid',
    borderColor: '#FFF',
    margin: 0,
    backgroundColor: '#FFF',
    fontSize: 13,
    height: 15,
    fontWeight: 'normal',
    color: 'rgba(0, 0, 0, 0.87)',
    textTransform: 'none',
    lineHeight: 0,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#FFF'
    }
  },
  drag_add: {
    width: 50,
    height: 50,
    color: '#FFF',
    pointerEvents: 'none'
  },
  addIcons: {
    fill: 'royalblue'
  },
  spanClass: {
    margin: '0px -7px !important'
  },
  noTextTable: {
    marginTop: '16px'
  }
})

interface MyProps extends StyledProps {
  sidebarOpen?: boolean;
  onClickCreateProduct?: (e) => void;
  searchText?: string
  catalog: CatalogStore
}

class ProductLandingStore {
  constructor(public catalog: CatalogStore) {

  }
  get dragDropEvents() {
    return new DragDropEventHandlers(this.catalog, {target: 'GroupByCatalog0'})
  }
}

@((withStyles as any)(styles))
@observer
export class ProductLandingComponent extends React.Component<MyProps> {
  @observable isDragOver = false
  @observable loading = false

  store: ProductLandingStore

  constructor(props) {
    super(props)
    this.store = new ProductLandingStore(props.catalog)
  }

  render() {
    const {
        isDragOver, loading, store,
        props: {
          classes,
          sidebarOpen,
          catalog
        }
      } = this,
      {
        dragDropEvents: {
          onDragEnter,
          onDragLeave,
          onDrop
        },
        catalog: {settings: {activeSearchText}}
      } = store
    return (
      <div onDragEnter={onDragEnter} onDragLeave={onDragLeave} onDrop={onDrop} className={classNames(css.root, sidebarOpen ? classes.emptyWithSidebar : classes.emptyContainer)}>
        <div className={css.dragContainer}>
          {!catalog && this.renderCatalog()}
          {isDragOver ? this.renderDragOverDiv() : loading || !_.isEmpty(activeSearchText) && (catalog.itemCount !== 0) ? (
            null
          ) : this.renderMessageContent()}
        </div>
      </div>
    )
  }

  renderDragOverDiv = () => {
    const {props: {classes}} = this
    return <div
      key='drag-add'
      className={css.drag}
      // onDragOver={this.onDragEnter}
      // // onDragLeave={this.onDragLeave}
      // onDrop={this.onDrop}
    >
      <Add className={classes.drag_add}/>
    </div>
  }

  get catalog() { return this.props.catalog }
  renderCatalog = () => {
    const {catalog: {filter: {state: {groups: {status}}, hasFilterTerms, ...filter}}} = this
    const {classes} = this.props
    return <div key='filters'
                className={hasFilterTerms ? classes.filterChips : classes.noFilterChips}
    >
      <FlatButton
        disabled={false}
        classes={{root: classes.clearFilter}}
        onClick={filter.resetFilters}
      >
        Clear Filters
      </FlatButton>
      {this.renderProductFilteredList()}
      {status.selected.has('active') ? (
        <Chip
          key="active"
          label="Active"
          className={classes.chip}
          deleteIcon={<ClearIcon className={classes.deleteIconStyle}/>}
          onDelete={() => filter.remove('status', 'active')}
        />
      ) : (
         <Fragment></Fragment>
       )}
    </div>
  }

  renderProductFilteredList = () => {
    return _.map(listFilters, thisFilterType => {
      const {catalog: {filter: {state: {groups}, ...filter}}} = this
      const {classes} = this.props
      if (groups[thisFilterType]?.selected.size) {
        const {selected} = groups[thisFilterType]
        return _.map(Array.from(selected.keys()), (key: string) => {
          const {id, name} = selected[key]
          return (
            <Chip
              key={`$${thisFilterType}-${id}`}
              label={name}
              className={classes.chip}
              deleteIcon={
                <ClearIcon className={classes.deleteIconStyle}/>
              }
              onDelete={() =>
                filter.remove(thisFilterType, id)
              }
            />
          )
        })
      }
      return <div key={thisFilterType}/>
    })
  }

  renderMessageContent = () => {
    const {
      catalog,
      catalog: {
        loadingCounts, settings: {viewMode}, createProduct, massCreate: {openCreateProductsDialog},
        filter: {state: {search: searchText}},
        vlp: {isVLPView}
      }} = this,
      {
        classes
      } = this.props

    if (loadingCounts) { return <LoadingIndicator/> }
    return <div className={classNames(classes.landing, {[classes.alignment]: _.isEmpty(searchText)})}>
      {!_.isEmpty(searchText) ?
       <Typography classes={{root: classNames(classes.helperText, {[classes.noTextTable]: viewMode === 'table'})}}>
         {`No ${isVLPView ? 'color' : 'product'} found for the search: ${searchText}`}
       </Typography> : <div className={css.emptyLibrary}>
         <Card className={classes.imageCard}>
           <CardMedia
             className={classes.imageCardMedia}
             image={landingScreen}
             title='Process Explanation'
           />
         </Card>
         <Typography>
           Looks like your library is empty!
           <br/>
           <br/>
           {!isVLPView ? !nav.params.category2
                         ? <Fragment>You must be in a category 2 to add items to the library.</Fragment>
                         : <Fragment>
                           Use the <Button icon={<span className={classes.spanClass}><AddIcon className={classes.addIcons}/></span>} onClick={() => createProduct()}/> button to create an Item.
                           <br/>
                           Or
                           <br/>
                           Use the <Button icon={<span className={classes.spanClass}><AddManyIcon className={classes.addIcons}/></span>} onClick={openCreateProductsDialog}/> to bulk
                           create Items.
                         </Fragment> : null}
         </Typography>
       </div>}
      <ProductCountPopOver catalog={catalog}/>
    </div>
  }

//   @action onDragEnter = (e) => {
//     if (!stores.nav.params.category2) return

//     e.preventDefault()
//     e.stopPropagation()
//     if(!this.isDragOver) {
//       this.isDragOver = stores.nav.params.category2 != null
//     }
//       }

//   @action onDragLeave = (e) => {
//     if (!stores.nav.params.category2) return

//     e.preventDefault()
//     e.stopPropagation()
//     const { catalog: {dragDrop} } = stores
//     this.isDragOver = false
//     dragDrop.reset()
//   }

//   @action onDrop = async (e) => {
//     const {nav: {params: {category2}}, catalog: {massCreate, dragDrop}, dragDrop: {dragItem}, filter: {shouldShowFilterBar}} = stores
//     if (!category2 || !dragItem) return

//     e.preventDefault()
//     e.stopPropagation()
//     this.isDragOver = false
//     this.loading    = true

//     try {
//       const {dragType} = dragItem

//       if(_.isEmpty(dragType)) {
//         const monitor = e.dataTransfer
//         if(monitor) {
//           let files: any = []
//           if(_.isEmpty(monitor.files)) {
//             // File is dropped from browser window
//             const file = await stores.upload.getImageFromDragImage(monitor)
//             files = [file]
//           } else {
//             files = monitor.files
//           }

//           if(files && files.length) {
//             massCreate.createProductWithImages(files)
//             return
//           }
//         }
//       }
// /* NYI - ES
//       let input : any = {}
//       if (gql.mapping.specToProductField[dragType]) {
//         input[gql.mapping.specToInputField[dragType]] = id
//       }
//       else if (dragType == 'customAttributes') {
//         let attrDef          = caDefByName[defnName]
//         input.attributes = [
//           {
//             definition: defnName,
//             boolVal:    attrDef.type === 'Boolean' ? id : null,
//             intVal:     attrDef.type === 'Int' ? id : null,
//             floatVal:   attrDef.type === 'Float' ? id : null,
//             strVal:     attrDef.type === 'String' ? id : null
//           }
//         ]
//       }
//       else if (dragType == 'tag') {
//         input.tags = [{id}]
//       }
//       else if (dragType == 'customTags') {
//         let attrDef          = caDefByName[defnName]
//         input.attributes = [
//           {
//             definition: defnName,
//             tag:        attrDef.type === 'Tag' ? id : null,
//             tagList:    attrDef.type === 'TagList' ? [id] : []
//           }
//         ]
//       }

//       const p = await createProduct({productInput: input})*/
//     }
//     finally {
//       // After load we should be visible unless we're filtered out
//       if (shouldShowFilterBar) {
//         // Wait to unset loading so that the parent has time to load in the new result
//         setTimeout(() => {this.loading = false}, 1000)
//       }
//       dragDrop.reset()
//     }
//   }
}



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/ProductLanding.tsx